import React from 'react';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';

const EnableAlisaField = ({ form, initialValue }) => {
  const handleChange = (e) => {
    if (e.target.checked === false) {
      form.resetFields([fieldNames.alisaText]);
    }
  };

  return (
    <Field
      fieldType={fieldTypes.checkbox}
      form={form}
      name={fieldNames.enableAlisa}
      decoratorOptions={{
        initialValue: typeof initialValue === 'boolean' ? initialValue : false,
      }}
      fieldProps={{ children: 'Включить автоответчик', onChange: handleChange }}
    />
  );
};

export default EnableAlisaField;
